module.exports = __webpack_public_path__ + "static/media/No_Project_Assigned_Client.92450ac4.svg";